import * as types from './mutation-types'
const state = {
  photographerRequest: []
}

const getters = {
  photographerRequest: state => state.photographerRequest
}

const actions = {
  // async [types.GET_PHOTOGRAPHER_REQUEST]({ dispatch, commit }, payload) {
  //   await new RequestApi().request().then(result => {
  //     console.log('photographer request', result)
  //     if (result) {
  //       commit(types.GET_PHOTOGRAPHER_REQUEST, result)
  //     } else {
  //       commit(types.GET_PHOTOGRAPHER_REQUEST, [])
  //     }
  //   })
  // }
  // async [types.SET_PHOTOGRAPHER_REQUEST]({ dispatch, commit }, payload) {
  //   await new RequestApi().request().then(result => {
  //     1
  //   })
  // },
  // async [types.POST_PHOTOGRAPHER_REQUEST]({ dispatch, commit }, payload) {
  //   await new RequestApi().request().then((result) => {})
  // }
}

const mutations = {
  [types.GET_PHOTOGRAPHER_REQUEST](state, result) {
    state.photographerRequest = result
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
